import Vue from 'vue';
import Vuex from 'vuex';
import productFilter from './modules/productFilter';
import user from './modules/user';
import order from './modules/order';
import unfinishOrder from './modules/unfinishOrder';
import writeStore from './modules/writeStore';
import invoice from './modules/invoice';
import quote from './modules/quote';
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        productFilter,
        user,
        order,
        unfinishOrder,
        writeStore,
        invoice,
        quote,
    },
    getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js